module.exports = __webpack_public_path__ + "img/auckland-branch.d868ac68.jpg";